import type { EntityAction, EntityCollection, FireCMSContext } from "@firecms/core";
import { AddIcon } from "@firecms/ui";
import type { Space } from "../collections/spaces";
import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";
import { tableOnlyEntityAction } from "./entityActionDefaults";
import { ImportLearningPathModal } from "./ImportLearningPathModal";

function openImportLearningPathDialog(
  context: FireCMSContext,
  params: {
    accountId: string;
    spaceId: string;
    spaceCollection: EntityCollection<Space>;
  }
): void {
  context.dialogsController.open({
    key: `import-learning-path-${params.spaceId}`,
    Component: ({ open, closeDialog }) => (
      <ImportLearningPathModal
        open={open}
        onClose={closeDialog}
        accountId={params.accountId}
        spaceId={params.spaceId}
        spaceCollection={params.spaceCollection}
      />
    ),
  });
}

export function buildImportLearningPathEntityAction(
  accountId: string
): EntityAction<Space> {
  const t = getAdminT(getAdminUiLocale());

  return {
    key: "import-learning-path",
    name: t("learningPathImport.entityAction"),
    icon: <AddIcon />,
    ...tableOnlyEntityAction,
    collapsed: false,
    onClick: ({ entity, context }) => {
      if (!entity) {
        return;
      }
      openImportLearningPathDialog(context, {
        accountId,
        spaceId: entity.id,
        spaceCollection: {
          path: entity.path,
        } as EntityCollection<Space>,
      });
    },
  };
}
